import { Alert, AlertIcon, AlertTitle, AlertDescription, Box, Text, CloseButton } from '@chakra-ui/react'
import { useState, useEffect } from 'react'

export function BrowserCompatibilityWarning() {
  const [browserInfo, setBrowserInfo] = useState<{
    isSamsungInternet: boolean
    isUnsupported: boolean
    userAgent: string
    browserName: string
  }>({
    isSamsungInternet: false,
    isUnsupported: false,
    userAgent: '',
    browserName: ''
  })
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const userAgent = navigator.userAgent
    const isSamsungInternet = /SamsungBrowser/i.test(userAgent) || 
                             (userAgent.includes('Android') && userAgent.includes('Samsung'))
    
    // Detect browser name
    let browserName = 'Unknown'
    if (userAgent.includes('Chrome')) browserName = 'Chrome'
    else if (userAgent.includes('Firefox')) browserName = 'Firefox'
    else if (userAgent.includes('Safari')) browserName = 'Safari'
    else if (userAgent.includes('Edge')) browserName = 'Edge'
    else if (isSamsungInternet) browserName = 'Samsung Internet'
    
    // Check for unsupported browsers
    const isUnsupported = isSamsungInternet || 
                         userAgent.includes('Internet Explorer') ||
                         userAgent.includes('MSIE')

    setBrowserInfo({
      isSamsungInternet,
      isUnsupported,
      userAgent,
      browserName
    })
  }, [])

  // Auto-close after 12 seconds
  useEffect(() => {
    if (browserInfo.isUnsupported && isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false)
      }, 12000) // 12 seconds

      return () => clearTimeout(timer)
    }
  }, [browserInfo.isUnsupported, isVisible])

  if (!browserInfo.isUnsupported || !isVisible) {
    return null
  }

  const handleClose = () => {
    setIsVisible(false)
  }

  return (
    <Box position="fixed" top={0} left={0} right={0} zIndex={9999} p={4}>
      <Alert status="warning" borderRadius="md" boxShadow="lg">
        <AlertIcon />
        <Box flex="1">
          <AlertTitle>Browser Compatibility Warning</AlertTitle>
          <AlertDescription>
            {browserInfo.isSamsungInternet ? (
              <>
                <Text fontWeight="bold">Samsung Internet Browser detected</Text>
                <Text mt={2}>
                  Voice commands may not work properly in Samsung Internet Browser. 
                  For the best experience, please use:
                </Text>
                <Text mt={1}>• Google Chrome</Text>
                <Text>• Mozilla Firefox</Text>
                <Text>• Safari (iOS)</Text>
                <Text>• Microsoft Edge</Text>
              </>
            ) : (
              <>
                <Text fontWeight="bold">Unsupported Browser</Text>
                <Text mt={2}>
                  Your browser ({browserInfo.browserName}) may not support all features. 
                  Please use a modern browser for the best experience.
                </Text>
              </>
            )}
          </AlertDescription>
        </Box>
        <CloseButton
          alignSelf="flex-start"
          position="relative"
          right={-1}
          top={-1}
          onClick={handleClose}
        />
      </Alert>
    </Box>
  )
} 